// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"febce9a3","647":"12e90aee"}[chunkId] + ".chunk.js";
};